import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import permission from './modules/permission';
import tagsView from './modules/tags-view';
import user from './modules/user';
import getters from './getters';

Vue.use(Vuex);

let store = new Vuex.Store({
    modules: {
        app,
        user,
        permission,
        tagsView,
    },
    getters,
});

export default store;
